const ErrorPage = () => {
  return <div>Page not found</div>;
};
export default ErrorPage;
